import {observer} from "mobx-react";
import {Box, Card, CardContent, CardMedia, Typography, useMediaQuery, useTheme} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'
import './ShopShortcut.css'
import {useStore} from "../../stores/Store";
import {useNavigate} from "react-router-dom";
import accordionRentalImg from '../../assets/img/rental.jpg'
import accordionBuyImg from '../../assets/img/purchase.jpg'
import ShareIcon from '@mui/icons-material/Share';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';


export default observer(function HomeShopShortcut(){
    const {LanguageStore} = useStore();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const navigate = useNavigate();

    const handlePictureClick = (site: 'rent' | 'buy') => {
        navigate(`/Accordions/${site}`);
    }

    return (
            <Grid container rowSpacing={4}>
                <Grid xs={12}>
                    <Typography sx={(isSmallScreen) ? {mt: 4, mb: 4} : {mr: 16, ml: 16, mt: 4, mb: 4}}>
                        {LanguageStore.currentLanguageMessages.HomePage.HomeShopShortcut.titleText}
                    </Typography>
                </Grid>
                <Grid xs={12}>
                    <Card
                        className={'clickable'}
                        sx={{m: (isSmallScreen) ? 2 : 8}}
                        onClick={() => handlePictureClick('buy')}
                    >
                        <CardMedia
                            sx={{display: 'flex', justifyContent: 'center'}}
                        >
                            <img
                                alt={'Buying Image'}
                                src={accordionBuyImg}
                                style={{height: (isSmallScreen) ? 200 : 400}}
                            />
                        </CardMedia>
                        <CardContent>
                            <Typography
                                variant={(isSmallScreen) ? 'h6' : 'h4'}
                                fontWeight={'500'}
                                textAlign={'center'}
                            >
                                <ShoppingBagOutlinedIcon sx={{mr: 2}} />
                                {LanguageStore.currentLanguageMessages.ShopShortcut.buy}
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card
                        className={'clickable'}
                        sx={{m: (isSmallScreen) ? 2 : 8}}
                        onClick={() => handlePictureClick('rent')}
                    >
                        <CardMedia
                            sx={{display: 'flex', justifyContent: 'center'}}
                        >
                            <img
                                alt={'Rental Image'}
                                src={accordionRentalImg}
                                style={{height: (isSmallScreen) ? 200 : 400}}
                            />
                        </CardMedia>
                        <CardContent>
                            <Typography
                                variant={(isSmallScreen) ? 'h6' : 'h4'}
                                fontWeight={'500'}
                                textAlign={'center'}
                            >
                                <ShareIcon sx={{mr: 2}} />
                                {LanguageStore.currentLanguageMessages.ShopShortcut.rent}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
    )
})